import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const Container = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1r2ixv-0"
})(["display:flex;margin-block-start:", ";"], ({
  theme
}) => theme.cardListItem.content.marginBlockStart);
const ImageContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1r2ixv-1"
})(["min-width:", ";max-width:", ";margin-inline-end:", ";"], ({
  theme
}) => theme.cardListItem.image.minWidth, ({
  theme
}) => theme.cardListItem.image.maxWidth, ({
  theme
}) => theme.cardListItem.content.marginInlineEnd);
const Grid = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1r2ixv-2"
})(["width:100%;", ""], ({
  $minColumnWidth
}) => ({
  'column-width': `${$minColumnWidth}px`
}));
const Row = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1r2ixv-3"
})(["margin-bottom:2px;page-break-inside:avoid;break-inside:avoid;"]);
const DataItem = /*#__PURE__*/styled.dl.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1r2ixv-4"
})(["margin-block-start:0;margin-block-end:0;display:flex;word-break:break-word;color:", ";font:", ";", ""], ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.font.text.small.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.small.mobile)));
const DataLabel = /*#__PURE__*/styled.dt.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1r2ixv-5"
})(["font-weight:normal;display:inline;margin-inline-end:", ";"], ({
  theme
}) => theme.cardListItem.content.dataLabel.marginInlineEnd);
const DataValue = /*#__PURE__*/styled.dd.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1r2ixv-6"
})(["display:inline;margin-inline-start:", ";"], ({
  theme
}) => theme.cardListItem.content.dataValue.marginInlineStart);
const DefaultBody = ({
  dataRows,
  image,
  minColumnWidth = 250
}) => /*#__PURE__*/React__default.createElement(Container, null, image && /*#__PURE__*/React__default.createElement(ImageContainer, null, image), /*#__PURE__*/React__default.createElement(Grid, {
  $minColumnWidth: minColumnWidth
}, dataRows.map(({
  label,
  value,
  renderAfter
}) => /*#__PURE__*/React__default.createElement(Row, {
  key: label
}, /*#__PURE__*/React__default.createElement(DataItem, null, /*#__PURE__*/React__default.createElement(DataLabel, null, label, ":"), /*#__PURE__*/React__default.createElement(DataValue, null, value)), renderAfter && renderAfter))));

export { DefaultBody as D };
//# sourceMappingURL=DefaultBody-BqZKgWS5.js.map
